import React from "react"
import styled from "styled-components"
import {Flex} from "../../../components/Flex"
import planeSVG from "../images/plane.svg"
import {ReportCard} from "./ReportCard"

const TripDetails = (props) => {
  return (
    <ReportCard collapsible={false} padded>
      <Flex>
        <DetailsDiv>
          <TitleDiv>
            <strong>Assignment for {props.assigneeName}</strong> (
            {props.assigneeId})
          </TitleDiv>
          <DescriptionDiv>{props.organization}</DescriptionDiv>
        </DetailsDiv>
        <TravelInfoDiv>
          <TitleDiv>
            <Flex>
              <div>
                <strong>{props.startLocation}</strong>
              </div>
              <IconDiv>
                <img src={planeSVG} alt="plane" />
              </IconDiv>
              <div>
                <strong>{props.endLocation}</strong>
              </div>
            </Flex>
          </TitleDiv>
          <DescriptionDiv>
            From {props.renderDate(props.startDate)} to{" "}
            {props.renderDate(props.endDate)}
          </DescriptionDiv>
        </TravelInfoDiv>
      </Flex>
    </ReportCard>
  )
}

const DescriptionDiv = styled.div`
  font-size: ${(props) => props.theme.fontSizeSmall}px;
`

const DetailsDiv = styled.div`
  flex-grow: 1;
`

const IconDiv = styled.div`
  height: 1.5em;
  margin: 0 0.5em;
  img {
    height: 100%;
  }
`

const TravelInfoDiv = styled.div`
  text-align: right;
`

const TitleDiv = styled.div`
  line-height: 1.5em;
  margin-bottom: 0.25em;
  margin-top: -0.25em;
`

export {TripDetails}
